import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e95c611"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select_none" }
const _hoisted_2 = { class: "select_nav" }
const _hoisted_3 = { class: "live_select" }
const _hoisted_4 = { class: "content_square" }
const _hoisted_5 = { class: "mod_pagin establish_pagation" }

import { Input, message, Pagination } from 'ant-design-vue';

import { ref, reactive, computed } from 'vue';

import { SearchOutlined } from '@ant-design/icons-vue';

import roomLower from './roomLower.vue';
import type { RootLive } from '@/store/modules/live/types';
import http from '@/api/subordinate';
import { useRoute } from 'vue-router';

const __default__ = { name: '' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as { data: any };

const route = useRoute();
const aInputSearch = Input.Search;
const aPagination = Pagination;
const checked_select = ref(false);
const selectKeys = ref({});
const isChecked = computed(() => {
  return checked_select.value;
});

// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 100, // 总数
  options: ['12', '24', '36', '48', '60'], // 选项
});
const changeItemMark = (item: RootLive) => {
  selectKeys.value[item.id] = !selectKeys.value[item.id];
};
//选择
const setSelectAll = () => {
  if (checked_select.value === false) {
    Object.keys(selectKeys.value).forEach((k, index) => {
      selectKeys.value[k] = false;
    });
  }
};


// 获取下级账号直播间列表
const subAccountLiveList = () => {
  let suboard = {
    subordinate_id: props.data.id,
  };
  http
    .getSubAccountLiveList({ params: suboard })
    .then((res) => {
      const degree = res.data.data.data;
      if (res.data.code == 200) {
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
subAccountLiveList();
const setDelete = (item: any) => {
  let subaccount = {
    subordinate_id: props.data.id,
    sub_studio_id: route.params.studioId,
  };
  http
    .getDelSubAccountLiveStudio({ params: subaccount })
    .then((res) => {
      if (res.data.code == 200) {
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(aInputSearch), {
            class: "container_search",
            placeholder: "搜索直播间"
          }, {
            enterButton: _withCtx(() => [
              _createVNode(_unref(SearchOutlined))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_checkbox, {
              class: "live_checkbox",
              checked: checked_select.value,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((checked_select).value = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (setSelectAll()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("选择")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_component_a_button, {
              class: "live_del",
              onClick: setDelete
            }, {
              default: _withCtx(() => [
                _createTextVNode("删除")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (item) => {
            return _createElementVNode("div", {
              key: item.id
            }, [
              _createVNode(roomLower, {
                "data-source": item,
                checked_select: _unref(isChecked),
                selected: selectKeys.value[item.id],
                "onSelect:changeItemMark": changeItemMark
              }, null, 8, ["data-source", "checked_select", "selected"])
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(aPagination), {
          "show-quick-jumper": "",
          total: pageConfig.totalSize,
          current: pageConfig.current,
          "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig.current) = $event)),
          "page-size": pageConfig.pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageConfig.pageSize) = $event)),
          pageSizeOptions: pageConfig.options,
          "show-less-items": "",
          "show-size-changer": ""
        }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
      ])
    ])
  ]))
}
}

})